import { useState } from "react";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { DashboardStats } from "@/components/admin/dashboard/Stats";
import { RecentShipments } from "@/components/admin/dashboard/RecentShipments";
import { TopCustomers } from "@/components/admin/dashboard/TopCustomers";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("shipments");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between space-x-2">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
            Dashboard
          </h1>
          <p className="text-gray-600">
            Welcome back! Here's what's happening with the platform.
          </p>
        </div>

        <Link to="/admin/shipments/new">
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            New Shipment
          </Button>
        </Link>
      </div>

      <DashboardStats />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="shipments">Recent Shipments</TabsTrigger>
          <TabsTrigger value="customers">Top Customers</TabsTrigger>
        </TabsList>

        <TabsContent value="shipments">
          <RecentShipments />
        </TabsContent>

        <TabsContent value="customers">
          <TopCustomers />
        </TabsContent>
      </Tabs>
    </div>
  );
}
